export default "<h1>Hello from imagePickerSearchComponent.html!</h1> <h2>vm.name = {{ vm.name }}</h2> ";